<template> 
    <div>
        <!-- 点关闭或确认都是一个功能 -->
         <!-- 商品列表 -->
        <el-dialog v-dialogDrag title="商品列表" :visible.sync="goodsShow" width="60%"  :close-on-click-modal="false" :before-close="goodsClose" >
            <span>从商品归类表中查询到了下列商品，请选择：</span>
            <el-table ref="goosListTable" :data="goodsList" highlight-current-row @current-change="goodsChange" max-height="400px">
                <el-table-column property="hsCode" label="商品编码" width="120"></el-table-column>
                <el-table-column property="hsName" label="商品名称" width="200"></el-table-column>
                <el-table-column property="hsUnit" label="计量单位" width="120"></el-table-column>
                <el-table-column property="hsDes" label="备注"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="sureGoods('1')">确 定</el-button>
            </span>
        </el-dialog> 
        <!-- 商品规范申报-商品申报要素 -->
        <el-dialog v-dialogDrag title="商品列表" :visible.sync="goodsDetails" width="60%" :before-close="goodsDetailsClose" :close-on-click-modal="false" >
            <span class="">规格型号（根据海关规定，以下要素应全部填报）。</span>
            <el-descriptions class="margin-top" :column="1" size="mini" border  >
                <el-descriptions-item label="商品信息" labelStyle="width:200px"> 
                    {{ goodsDetailsText.hsName }}
                </el-descriptions-item>
                <el-descriptions-item v-for="item,index in goodsDetailsText.hsElements" :key="index" :label="item.elementName">
                    <template slot="label">
                        <span v-if="item.elementRequired" style="color: rgb(245, 108, 108);"> * </span>
                        {{ item.elementName }}
                    </template>
                    <el-select size="mini" :class="item.elementRequired?'yellow width_100' : 'width_100'" v-if="item.elementName === '品牌类型'" filterable  :disabled ="exit"
                    :default-first-option="true" v-model="item.elementValue" placeholder="品牌类型" @change="linkElementValue">
                        <el-option  v-for="item in brandType" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue"> 
                            <span class="margin_right_20">{{ item.codeValue }}</span>
                            <span >{{ item.codeName }}</span> 
                        </el-option>
                    </el-select>
                    <el-select size="mini" :class="item.elementRequired?'yellow width_100' : 'width_100'" v-else-if="item.elementName === '出口享惠情况'" filterable  :disabled ="exit"
                    :default-first-option="true" v-model="item.elementValue" placeholder="出口享惠情况" @change="linkElementValue">
                        <el-option  v-for="item in exportBenefits" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue"> 
                            <span class="margin_right_20">{{ item.codeValue }}</span>
                            <span >{{ item.codeName }}</span> 
                        </el-option>
                    </el-select>
                    <el-input :disabled ="exit" @input="linkElementValue" v-else-if="item.elementName === '签约日期'" v-model="item.elementValue" size="mini"
                    onkeyup="value=value.match(/\d{0,8}/,'')" :class="item.elementRequired?'yellow' : ''"></el-input>
                    <el-input :disabled ="exit" @input="linkElementValue" v-else v-model="item.elementValue" size="mini" :class="item.elementRequired?'yellow' : ''"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="规格型号"> 
                    <div class="flex_sb">
                        <span>
                            {{ specificationModel }} 
                        </span>
                        <span>
                            ( {{ specificationModelNum }} /255字节 )
                        </span>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="sureGoodsDetails">确 定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'

export default {
    props: {

    },
    data() {
        return {
            exit:true, // 是否编辑
            type:'1', // 是否是重新归类
            codeTs:'',// 商品编号
            goodsShow:false,
            goodsDetails:false,
            goodsList:[], // 商品列表
            goodsDetailsVal:{}, // 选中商品信息
            goodsDetailsText:{}, // 商品详细信息
            brandType: AEObasicData.BrandType, // 品牌类型
            exportBenefits:AEObasicData.ExportBenefits, // 出口享惠情况
            specificationModel:'',// 规格型号
            specificationModelNum:0, // 规格型号字节
        }
    },
    watch: {
    },
    mounted() { 
    },
    methods: { 
        // 获取商品列表
        getGoodsList(codeTs){
            this.codeTs = codeTs
            this.$api.getGoodsBy(  this.codeTs  ).then(res =>{
                this.goodsList = res
                this.goodsShow = true
                // 默认选中第一个
                setTimeout(() => {
                    this.$refs.goosListTable.setCurrentRow(this.goodsList[0]);
                }, 100); 
            })
        },
        // 选中商品时
        goodsChange(val){
            this.goodsDetailsVal = val
        },
        // 关闭商品列表弹窗
        goodsClose(){
            this.goodsShow = false
            this.codeTs = ''
            this.goodsList = []
        },
        // 确认选中商品时
        sureGoods(type,exit,fatherCode,fatherModel) {
            this.type = type
            // 是否编辑
            this.exit = exit
            // type 1 : 选择商品列表  ; type 0 :重新归类
            if(type === '0'){
                // 重新归类
                this.$api.getHsCiqByHsCode(  fatherCode  ).then(res =>{
                    this.goodsDetailsText = res
                    // 将父页面的值赋值到goodsDetailsText中
                    if(fatherModel !== ''){
                        var value = fatherModel.split('|')
                    }
                    this.goodsDetailsText.hsElements = this.goodsDetailsText.hsElements.split("$").map(item =>{
                            const elementName = item.split(":")[1]
                            const elementRequired = item.split(":")[2] === '1' ? true : false
                            return {elementName:elementName,elementValue:"",elementRequired:elementRequired}
                    })
                    this.goodsDetailsText.hsElements.forEach((item,index) =>{
                        item.elementValue = value[index] ? value[index] : ''
                    })
                    this.specificationModel = fatherModel
                    this.goodsDetails = true
                },error =>{
                    setTimeout(() => {
                        this.$message({
                            type: 'error',
                            message: '找不到对应code的HS码,请重新输入商品编号!',
                            customClass: 'messageIndex'
                        })
                    }, 100)
                })
            }else{
                // 查询详细商品信息,不是重新归类
                if(this.goodsDetailsVal.hsCode){
                    this.$api.getHsCiqByHsCode(  this.goodsDetailsVal.hsCode  ).then(res =>{
                        this.goodsDetailsText = res
                        this.goodsDetailsText.hsElements = this.goodsDetailsText.hsElements.split("$").map(item =>{
                            const elementName = item.split(":")[1]
                            const elementRequired = item.split(":")[2] === '1' ? true : false
                            return {elementName:elementName,elementValue:"",elementRequired:elementRequired}
                        })
                        this.goodsShow = false
                        this.goodsDetails = true
                    })
                }
            }
        },
        // 输入规格型号时
        linkElementValue(){
            let value = this.goodsDetailsText.hsElements.map(item => {
                return item.elementValue + '|';
            }).join("");
            //删除最后连续|
            this.specificationModel = value.replace(/\|+$/, '');;
            // 计算字节长度
            const chinese = /[^\x00-\xff]/g; //匹配所有非 ASCII 字符，特别是双字节字符
            let newVal = this.specificationModel.replace(chinese,"**");
            this.specificationModelNum =  newVal.length;
            if(this.specificationModelNum > 255){
                this.$alert('规范申报要素归类后，规格型号数据超长，大于255字节', '提示', {
                    confirmButtonText: '确定',
                    callback: action => { }
                });
            }
        },
        // 确定商品申报要素
        sureGoodsDetails(){
            // 验证商品规格型号数据长度
            if(this.specificationModelNum <= 255){ 
                // 判断必填是否都写
                for(let item  of this.goodsDetailsText.hsElements){
                    if(item.elementRequired){
                        if(item.elementValue == ''){
                            this.$message({
                                message: '请填写必填项',
                                type: 'warning'
                            });
                            return false
                        }
                    }
                }
                if(this.goodsDetailsText.hsCode === '4011801100' || this.goodsDetailsText.hsCode === '4011809100'){
                     // 匹配数字部分和后面的非数字部分，允许中间有空格
                    const sizeValue = this.checkRimSize(this.goodsDetailsText.hsElements[4].elementValue)
                    // 判断sizeValue是否是数字
                    if(!isNaN(parseFloat(sizeValue))){
                        // 是数字类型
                        if(Number(sizeValue) > 61){
                            this.$message({
                                message: '辋圈尺寸需要≤61厘米',
                                type: 'warning'
                            });
                            return false
                        }
                    }else{
                        this.$message({
                            message: '请输入正确的辋圈尺寸',
                            type: 'warning'
                        });
                        return false
                    }
                }else if (this.goodsDetailsText.hsCode === '4011809200' || this.goodsDetailsText.hsCode === '4011801200'){
                    const sizeValue = this.checkRimSize(this.goodsDetailsText.hsElements[4].elementValue)
                    // 判断sizeValue是否是数字
                    if(!isNaN(parseFloat(sizeValue))){
                        // 是数字类型
                        if(Number(sizeValue) <= 61){
                            this.$message({
                                message: '辋圈尺寸需要>61厘米',
                                type: 'warning'
                            });
                            return false
                        }
                    }else{
                        this.$message({
                            message: '请输入正确的辋圈尺寸',
                            type: 'warning'
                        });
                        return false
                    }
                }else if (this.goodsDetailsText.hsCode === '4011200010'){
                    const sizeValue = this.checkRimSize(this.goodsDetailsText.hsElements[5].elementValue)
                    // 判断sizeValue是否是数字
                    if(!isNaN(parseFloat(sizeValue))){
                        // 是数字类型
                        if(Number(sizeValue) < 30){
                            this.$message({
                                message: '断面宽度需要≥30英寸',
                                type: 'warning'
                            });
                            return false
                        }
                    }else{
                        this.$message({
                            message: '请输入正确的断面宽度',
                            type: 'warning'
                        });
                        return false
                    }
                }else if(this.goodsDetailsText.hsCode === '4002191500'){
                    const parts = this.goodsDetailsText.hsElements[4].elementValue;
                    if(!parts.includes('非充油')){
                        this.$message({
                            message: '丁苯橡胶必须是非充油',
                            type: 'warning'
                        });
                        return false
                    }
                }else if(this.goodsDetailsText.hsCode === '4002191600'){
                    const parts = this.goodsDetailsText.hsElements[4].elementValue;
                    if(parts.includes('非充油')){
                        this.$message({
                            message: '丁苯橡胶必须是充油',
                            type: 'warning'
                        });
                        return false
                    }
                }
                this.$emit('goodsDetails',this.type,this.goodsDetailsText,this.specificationModel)
                this.goodsDetailsClose()
            }else{
                this.$alert('规范申报要素归类后，规格型号数据超长，大于255字节', '提示', {
                    confirmButtonText: '确定',
                    callback: action => { }
                });
            }
        },
        // 验证辋圈尺寸
        checkRimSize(value){
            var valueList = value.split(/(\d+)/).filter(Boolean)
            // 是否有小数点
            const hasDecimal = valueList.includes(".")
            if(hasDecimal){
                // 有小数点
                return valueList.slice(0, 3).join("")
            }else{
                // 没有小数点
                return valueList[0]
            }
        },
        // 关闭商品详情弹窗
        goodsDetailsClose(){
            this.goodsDetails = false
            this.goodsDetailsText = {}
            this.specificationModel = ''
            this.specificationModelNum = 0
        },

    }
}
</script>
<style lang="css" scoped>
.messageIndex.el-message {
  z-index: 9999 !important;
}
::v-deep .el-table__body tr.current-row>td.el-table__cell{
    background-color: #FAFFBD !important;
}
.yellow .el-input__inner {
    background-color: #FAFFBD;
}
.width_100{
    width: 100%;
}
.margin_right_20{
    margin-right: 20px;
}
.el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
.el-checkbox{
    white-space: normal;
    display: flex;
    align-self: flex-start;
    margin-top: 10px;
}
.flex_sb{
    display: flex;
    justify-content: space-between;
}
/* 输入框黄色 */
::v-deep .yellow .el-input__inner {
    background-color: #FAFFBD;
}
</style>